import { Layout } from 'antd'
import React from 'react'
import HomePage from '../../components/Client/HomePage';

const ClientHomePage = () => {
    return (
        <Layout>
            <Layout.Content>
                <HomePage />
            </Layout.Content>
        </Layout>
    )
}

export default ClientHomePage
